var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaixa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0f0;}.cls-2{fill:#031026;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#707785;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 154,
    height: 88,
    rx: 11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.14,40.5l-2.38,5.93h3.3l-.91-6v0ZM46.52,54.12,56.29,34h7.39L67.8,54.12H61.32l-.48-2.68H54.55L53.1,54.12Zm24.36,0L73.71,34h6.53L77.41,54.12Zm43.47-13.65-2.39,6h3.29l-.9-6ZM101.72,54.12,111.49,34h7.39L123,54.12h-6.49L116,51.44h-6.3l-1.45,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.27 44.72 95.46 44.72 101.07 54.01 92.88 54.01 87.27 44.72 87.27 44.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "88.12 43.29 96.58 43.29 103.94 34.03 95.47 34.03 88.12 43.29 88.12 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "79.65 54.07 88.12 54.07 95.47 44.7 87 44.7 79.65 54.07 79.65 54.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.7 33.92 90.61 33.92 96.02 43.29 88.12 43.29 82.7 33.92 82.7 33.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.71,34.72l-.62,5.92c-2.41-3.32-8-1-8.44,3.11-.55,5.26,4.82,6.48,7.75,3.39l-.63,5.93a14.7,14.7,0,0,1-2.57,1,10.94,10.94,0,0,1-2.51.36,9.9,9.9,0,0,1-2.86-.33A7.08,7.08,0,0,1,34.52,53a8.23,8.23,0,0,1-2.86-3.69,10.65,10.65,0,0,1-.58-5.08A12.5,12.5,0,0,1,32.23,40a12.05,12.05,0,0,1,2.51-3.43A10.65,10.65,0,0,1,38,34.38a10.4,10.4,0,0,1,3.87-.8,9.58,9.58,0,0,1,2.45.26,11.11,11.11,0,0,1,2.36.88Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixa);
export default __webpack_public_path__ + "static/media/caixa.960f4af4f49f71e730f21deed7b168e6.svg";
export { ForwardRef as ReactComponent };